// extracted by mini-css-extract-plugin
export default {"productGrid":"M1-z","centerLink":"N1-z","productSection":"O1-z","item":"P1-z","ctaButton":"Q1-z"};